


































import { Component, Vue } from 'vue-property-decorator'
import { $newObj, CustomerLeadEmployee } from '@immosparrow/cockpit-api-v2'

@Component
export default class Unsubscribe extends Vue {
  get id () {
    return this.$route.query?.leadListId as string
  }

  get agent () {
    return this.$store.getters.agentInfo || $newObj(CustomerLeadEmployee)
  }

  get agencyName () {
    return this.agent.agency?.name
  }

  get fullName () {
    return `${this.agent.firstName || ''} ${this.agent.lastName || ''}`
  }

  created () {
    if (this.id) this.$store.dispatch('unsubscribe', this.id)
  }
}
